var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationTo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 8.74971C5.75 9.54536 6.06607 10.3084 6.62868 10.871C7.19129 11.4336 7.95435 11.7497 8.75 11.7497C9.54565 11.7497 10.3087 11.4336 10.8713 10.871C11.4339 10.3084 11.75 9.54536 11.75 8.74971C11.75 7.95406 11.4339 7.191 10.8713 6.62839C10.3087 6.06578 9.54565 5.74971 8.75 5.74971C7.95435 5.74971 7.19129 6.06578 6.62868 6.62839C6.06607 7.191 5.75 7.95406 5.75 8.74971Z",
    stroke: "#343434",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.407 14.4067L10.164 18.6497C9.78899 19.0243 9.28059 19.2348 8.7505 19.2348C8.22042 19.2348 7.71202 19.0243 7.337 18.6497L3.093 14.4067C1.97422 13.2879 1.21234 11.8624 0.903691 10.3106C0.595043 8.75873 0.753494 7.15022 1.35901 5.68844C1.96452 4.22665 2.9899 2.97725 4.30548 2.09821C5.62107 1.21918 7.16777 0.75 8.75 0.75C10.3322 0.75 11.8789 1.21918 13.1945 2.09821C14.5101 2.97725 15.5355 4.22665 16.141 5.68844C16.7465 7.15022 16.905 8.75873 16.5963 10.3106C16.2877 11.8624 15.5258 13.2879 14.407 14.4067Z",
    stroke: "#343434",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationTo);
export default __webpack_public_path__ + "static/media/location-to.b8aea395872a04215823683087d57ce1.svg";
export { ForwardRef as ReactComponent };